export const ACI_API = `${import.meta.env.VITE_API_HOST}/aci/api`
export const BASE_API = `${import.meta.env.VITE_API_HOST}/overseas-manifest-unify/api`
export const COMMON_API = `${import.meta.env.VITE_API_HOST}/overseas-manifest-unify/api/common`
export const AMS_MEXICO_API = `${import.meta.env.VITE_API_HOST}/overseas-manifest-unify/api/ams-mexico`
export const AFR_API = `${import.meta.env.VITE_API_HOST}/afr`
export const OVERSEAS_API = `${import.meta.env.VITE_API_HOST}/overseas-manifest-common/api`
export const CONST_NAS_URL = `https:${import.meta.env.VITE_NAS_URL}/pass/proxy`
export const CONST_NAS_UPLOAD_URL = `https:${import.meta.env.VITE_NAS_URL}/whale/upload/v1`

export enum ManifestAction {
  NEW = 'new',
  COPY = 'copy',
  EDIT = 'edit',
  VIEW = 'view',
  RESEND = 'resend',
  HISTORY = 'history',
  HISTORY_DETAIL = 'historyDetail',
  AI = 'ai',
}

export enum BillTypePage {
  Detail = 'Detail',
}

export enum ManifestPageType {
  DRAFT_PAGE = 'DRAFT_PAGE',
  SEND_PAGE = 'SEND_PAGE',
}

/** 五字码类型 */
export enum FiveCodeType {
  /** 五字码 */
  UN_CODE = 'UN_CODE',
  /** 自定义 */
  CUSTOM = 'CUSTOM',
}

/** 空重箱状态 */
export enum EmptyStatus {
  LCL = 'LCL',
  FCL = 'Load',
  // EMT = 'EMT',
}

/** 货物运输方式 */
export enum ContainerIndicator {
  /** 散货运输 */
  BULK_CARGO = 'BULK_CARGO',
  /** 集装箱运输 */
  CONTAINER = 'CONTAINER',
}

/** 空重箱下拉选项（需在 setup 中调用） */
export const getEmptyStatusOptions = (t: (key: string) => string) => [
  { label: t('field.emptyStatusLCL'), value: EmptyStatus.LCL },
  { label: t('field.emptyStatusFCL'), value: EmptyStatus.FCL },
]

export const IS_GLOBAL = import.meta.env.VITE_IS_GLOBAL === 'true'

// 导出party类型常量
export {
  PARTY_TYPES,
  PARTY_TYPE_LABELS,
  PARTY_TYPE_OPTIONS,
} from './party-types'

/** 动态表单代码 */
export enum DYNAMIC_TABLE_CODE {
  /** 草稿列表 */
  DRAFT = 'ams_mexico_draft_list',
  /** 已发送列表 */
  SEND = 'ams_mexico_send_list',
  /** 消费列表*/
  CONSUME = 'ams_mexico_consume_list',
  /** 国际站消费记录 */
  GLOBAL_CONSUME = 'ams_mexico_global_consume_list',
}
